import { Component, OnInit } from '@angular/core';
import { MainRoute } from 'src/app/models/MainRoute';
import { RoutingService } from 'src/app/services/Routing.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  currentRoute: MainRoute;

  constructor() {
    this.currentRoute = RoutingService.getStationRoute();
  }

  ngOnInit(): void {
  }

}
